(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outlet-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-outlet-hero]').forEach((hero) => {
    if (hero.dataset.motionReady === 'true') return;
    hero.dataset.motionReady = 'true';

    const media = hero.querySelector('[data-outlet-hero-media]');
    const slides = [...hero.querySelectorAll('[data-outlet-slide]')];
    const controls = [...hero.querySelectorAll('[data-outlet-hero-control]')];
    const indexLabel = hero.querySelector('[data-outlet-hero-index]');
    const typeLabel = hero.querySelector('[data-outlet-hero-type]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let rotationTimer;

    const loadSlide = (slide) => {
      if (!slide?.dataset.sprite || slide.dataset.loaded === 'true') return;
      slide.style.setProperty('--oe-sprite', `url("${slide.dataset.sprite}")`);
      slide.dataset.loaded = 'true';
    };

    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      loadSlide(slides[activeIndex]);

      slides.forEach((slide, index) => {
        slide.dataset.active = String(index === activeIndex);
      });

      controls.forEach((control, index) => {
        control.setAttribute('aria-pressed', String(index === activeIndex));
      });

      if (indexLabel) indexLabel.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      if (typeLabel) {
        typeLabel.textContent = controls[activeIndex]?.getAttribute('aria-label') || '';
        if (!reduceMotion) {
          typeLabel.animate(
            [
              { opacity: 0, transform: 'translateY(80%)' },
              { opacity: 1, transform: 'translateY(0)' },
            ],
            { duration: 600, easing: 'cubic-bezier(.22,1,.36,1)' }
          );
        }
      }

      window.setTimeout(() => loadSlide(slides[(activeIndex + 1) % slides.length]), 500);
    };

    const startRotation = () => {
      if (reduceMotion || slides.length < 2) return;
      window.clearInterval(rotationTimer);
      rotationTimer = window.setInterval(() => showSlide(activeIndex + 1), 4800);
    };

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        showSlide(Number(control.dataset.slide));
        startRotation();
      });
    });

    hero.addEventListener('pointerenter', () => window.clearInterval(rotationTimer));
    hero.addEventListener('pointerleave', startRotation);
    hero.addEventListener('focusin', () => window.clearInterval(rotationTimer));
    hero.addEventListener('focusout', startRotation);
    showSlide(0);
    startRotation();

    if (!media || reduceMotion) return;

    hero.addEventListener('pointermove', (event) => {
      const bounds = media.getBoundingClientRect();
      const x = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
      const y = Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height));
      media.style.setProperty('--oe-parallax-x', `${(x - 0.5) * -10}px`);
      media.style.setProperty('--oe-parallax-y', `${(y - 0.5) * -7}px`);
    });

    hero.addEventListener('pointerleave', () => {
      media.style.setProperty('--oe-parallax-x', '0px');
      media.style.setProperty('--oe-parallax-y', '0px');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outlet-types"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-outlet-types]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !window.matchMedia('(pointer: fine)').matches) return;

    sections.forEach((section) => {
      section.querySelectorAll('.oe-type-card').forEach((card) => {
        if (card.dataset.motionReady === 'true') return;
        card.dataset.motionReady = 'true';

        card.addEventListener('pointermove', (event) => {
          const bounds = card.getBoundingClientRect();
          card.style.setProperty('--oe-x', `${event.clientX - bounds.left}px`);
          card.style.setProperty('--oe-y', `${event.clientY - bounds.top}px`);
        });

        card.addEventListener('pointerleave', () => {
          card.style.setProperty('--oe-x', '50%');
          card.style.setProperty('--oe-y', '50%');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
